define(function (require, exports, module) {
    'use strict';

    var env = require('../env');
    var normalizeToNfc = require('../string/normalizeToNfc');
    const escapeAdblock = require('lib/escapeAdblock').default;

    /**
     * @type namespace
     */
    var fileSystemPath = {
        /**
         * .DS_Store – парамтеры отображения директории в macOS
         * Desktop.ini – парамтеры отображения директории в Windows
         * Thumbs.db – эскизы изображений в Windows
         * ehthumbs.db – эскизы видеофайлов в Windows
         *
         * @type {RegExp}
         */
        ignoredFileNames: /^(\.DS_Store|(D|d)esktop\.ini|Thumbs\.db|ehthumbs\.db)$/,

        /**
         * @param {string} name
         * @returns {boolean}
         */
        isIgnoredFileName: function (name) {
            var isIgnoredFileName = fileSystemPath.ignoredFileNames.test(name);

            return isIgnoredFileName;
        },

        normalize: function (path) {
            // macOS использует Unicode NFD в именах файлов и папок,
            // а наш сервер преобразует все имена в NFC.
            // Нормальзуем локальные имена и пути в NFC,
            // чтобы избежать ошибок при сравнении строк.
            var result = normalizeToNfc(path);

            return result;
        },

        /**
         * @param {string} path
         * @returns {string}
         */
        getVisiblePath: function (path) {
            var result = path;

            if (env.isMacOS) {
                // Finder в macOS отображает пользователю в имени файла слэш,
                // но в браузер попадает строка, в которой слэш заменен на двоеточие.
                // Создать файл с двоеточием в имени в macOS невозможно.
                // Будем использовать символ, который видит пользователь.
                result = result.replace(/:/g, '/');
            }

            return result;
        },

        /**
         * @param {string} path
         * @returns {Object}
         */
        getFullName: function (path) {
            var lastChar = path.slice(-1);
            var name;

            if (lastChar === '/') {
                name = path.slice(0, -1);
            } else {
                name = path;
            }

            var lastIndex = name.lastIndexOf('/');

            if (lastIndex !== -1) {
                name = name.slice(lastIndex + 1);
            }

            return name;
        },

        /**
         * @param {string} path
         * @returns {Object}
         */
        getNameParts: function (path) {
            var urlComponents = {
                name: '',
                extension: '',
            };

            var fullName = escapeAdblock(fileSystemPath.getFullName(path));
            var lastIndex = fullName.lastIndexOf('.');

            if (lastIndex > 0) {
                urlComponents.name = fullName.slice(0, lastIndex);
                urlComponents.extension = fullName.slice(lastIndex + 1);
            } else {
                urlComponents.name = fullName;
                urlComponents.extension = '';
            }

            return urlComponents;
        },

        /**
         * @param {string} path
         * @returns {Object}
         */
        getVisibleNameParts: function (path) {
            var urlComponents = fileSystemPath.getNameParts(path);
            var name = urlComponents.name;
            var extension = urlComponents.extension;

            if (name) {
                urlComponents.name = fileSystemPath.getVisiblePath(name);
            }

            if (extension) {
                urlComponents.extension = fileSystemPath.getVisiblePath(extension);
            }

            return urlComponents;
        },

        join: function () {
            var path = arguments[0] || '';

            for (var i = 1; i < arguments.length; i++) {
                var pathPart = arguments[i];

                if (pathPart) {
                    var pathEndsWithSlash = path.charAt(path.length - 1) === '/';
                    var pathPartStartsWithSlash = pathPart.charAt(0) === '/';

                    if (pathEndsWithSlash && pathPartStartsWithSlash) {
                        path = path + pathPart.substring(1);
                    } else if (!pathEndsWithSlash && !pathPartStartsWithSlash) {
                        path = path + '/' + pathPart;
                    } else {
                        path = path + pathPart;
                    }
                }
            }

            return path;
        },
    };

    module.exports = fileSystemPath;
});
